import styled from 'styled-components'
import { GoogleAd } from '../../../sharedComponents'
import { adPlacementTextCss } from '../AdPlacementCss'

export const PlacementContainer = styled.div<{ dark?: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 1.77;
  overflow: hidden;
  background-color: ${({ dark }) => (dark ? '#1e1e1e' : '#f8f8f8')};
  ${adPlacementTextCss}
`

export const MobileAd = styled(GoogleAd)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
